var window =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["idify"] = __webpack_require__(1);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Valid ID or NAME attributes for an HTML entity must begin with a letter ([A-Za-z]) and may be followed by any
	 * number of letters, digits ([0-9]), hyphens ("-"), underscores ("_"), colons (":"), or periods (".").
	 *
	 * Invalid values can be found using the following regular expression: "[^A-Za-z0-9\-_:\.]"
	 * NOTE: The above regular expression will also capture spaces, to make these mildly readable spaces will be
	 * replaced with dashes after being collapsed to a maximum of 1 space.
	 *
	 * See: https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/id
	 */
	
	var invalidCharactersRegEx = /[^ A-Za-z0-9\-_:.]/g;
	var condenseSpacesRegEx = /[\s]+/g;
	
	var characterMap = __webpack_require__(2);
	
	function createId(input) {
	    // No need to do any processing if we didn't get anything to process.
	    if (!input) {
	        return '';
	    }
	
	    var returnValue = input.replace(invalidCharactersRegEx, function (character) {
	        // Replace with the mapped character (if available), otherwise remove the character.
	        return characterMap[character] || '';
	    }).trim().toLowerCase();
	
	    // Replace any space with a dash and condense any sets of multiple spaces into a single dash
	    return returnValue.replace(condenseSpacesRegEx, '-');
	}
	
	module.exports = createId;

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	/**
	 * A map of all of the non-control Unicode characters in Latin-1 and Lain Extended-A which have been transliterated
	 * into ASCII representations (where it makes sense and they should be represented within a URL) with usage in an ID
	 * or NAME attribute for an HTML entity in mind.
	 */
	
	var characterMap = {
	    ' ': ' ',
	    '¡': '',
	    '¢': 'c',
	    '£': 'lb',
	    '¥': 'yen',
	    '¦': '',
	    '§': '',
	    '¨': '',
	    '©': '',
	    'ª': 'a',
	    '«': '',
	    '¬': 'not',
	    '­': '-',
	    '®': '',
	    '°': '',
	    '±': '',
	    '²': '',
	    '³': '',
	    '´': '',
	    'µ': '',
	    '¶': '',
	    '·': '',
	    '¸': '',
	    '¹': '',
	    'º': 'o',
	    '»': '',
	    '¼': '',
	    '½': '',
	    '¾': '',
	    '¿': '',
	    'À': 'A',
	    'Á': 'A',
	    'Â': 'A',
	    'Ã': 'A',
	    'Ä': 'A',
	    'Å': 'A',
	    'Æ': 'AE',
	    'Ç': 'C',
	    'È': 'E',
	    'É': 'E',
	    'Ê': 'E',
	    'Ë': 'E',
	    'Ì': 'I',
	    'Í': 'I',
	    'Î': 'I',
	    'Ï': 'I',
	    'Ð': 'D',
	    'Ñ': 'N',
	    'Ò': 'O',
	    'Ó': 'O',
	    'Ô': 'O',
	    'Õ': 'O',
	    'Ö': 'O',
	    '×': 'x',
	    'Ø': 'O',
	    'Ù': 'U',
	    'Ú': 'U',
	    'Û': 'U',
	    'Ü': 'U',
	    'Ý': 'Y',
	    'Þ': 'Th',
	    'ß': 'ss',
	    'à': 'a',
	    'á': 'a',
	    'â': 'a',
	    'ã': 'a',
	    'ä': 'a',
	    'å': 'a',
	    'æ': 'ae',
	    'ç': 'c',
	    'è': 'e',
	    'é': 'e',
	    'ê': 'e',
	    'ë': 'e',
	    'ì': 'i',
	    'í': 'i',
	    'î': 'i',
	    'ï': 'i',
	    'ð': 'd',
	    'ñ': 'n',
	    'ò': 'o',
	    'ó': 'o',
	    'ô': 'o',
	    'õ': 'o',
	    'ö': 'o',
	    '÷': ':',
	    'ø': 'o',
	    'ù': 'u',
	    'ú': 'u',
	    'û': 'u',
	    'ü': 'u',
	    'ý': 'y',
	    'þ': 'th',
	    'ÿ': 'y',
	    'Ā': 'A',
	    'ā': 'a',
	    'Ă': 'A',
	    'ă': 'a',
	    'Ą': 'A',
	    'ą': 'a',
	    'Ć': 'C',
	    'ć': 'c',
	    'Ĉ': 'C',
	    'ĉ': 'c',
	    'Ċ': 'C',
	    'ċ': 'c',
	    'Č': 'C',
	    'č': 'c',
	    'Ď': 'D',
	    'ď': 'd',
	    'Đ': 'D',
	    'đ': 'd',
	    'Ē': 'E',
	    'ē': 'e',
	    'Ĕ': 'E',
	    'ĕ': 'e',
	    'Ė': 'E',
	    'ė': 'e',
	    'Ę': 'E',
	    'ę': 'e',
	    'Ě': 'E',
	    'ě': 'e',
	    'Ĝ': 'G',
	    'ĝ': 'g',
	    'Ğ': 'G',
	    'ğ': 'g',
	    'Ġ': 'G',
	    'ġ': 'g',
	    'Ģ': 'G',
	    'ģ': 'g',
	    'Ĥ': 'H',
	    'ĥ': 'h',
	    'Ħ': 'H',
	    'ħ': 'h',
	    'Ĩ': 'I',
	    'ĩ': 'i',
	    'Ī': 'I',
	    'ī': 'i',
	    'Ĭ': 'I',
	    'ĭ': 'i',
	    'Į': 'I',
	    'į': 'i',
	    'İ': 'I',
	    'ı': 'i',
	    'Ĳ': 'IJ',
	    'ĳ': 'ij',
	    'Ĵ': 'J',
	    'ĵ': 'j',
	    'Ķ': 'K',
	    'ķ': 'k',
	    'Ĺ': 'L',
	    'ĺ': 'l',
	    'Ļ': 'L',
	    'ļ': 'l',
	    'Ľ': 'L',
	    'ľ': 'l',
	    'Ŀ': 'L',
	    'ŀ': 'l',
	    'Ł': 'L',
	    'ł': 'l',
	    'Ń': 'N',
	    'ń': 'n',
	    'Ņ': 'N',
	    'ņ': 'n',
	    'Ň': 'N',
	    'ň': 'n',
	    'ŉ': 'n',
	    'Ō': 'O',
	    'ō': 'o',
	    'Ŏ': 'O',
	    'ŏ': 'o',
	    'Ő': 'O',
	    'ő': 'o',
	    'Œ': 'OE',
	    'œ': 'oe',
	    'Ŕ': 'R',
	    'ŕ': 'r',
	    'Ŗ': 'R',
	    'ŗ': 'r',
	    'Ř': 'R',
	    'ř': 'r',
	    'Ś': 'S',
	    'ś': 's',
	    'Ŝ': 'S',
	    'ŝ': 's',
	    'Ş': 'S',
	    'ş': 's',
	    'Š': 'S',
	    'š': 's',
	    'Ţ': 'T',
	    'ţ': 't',
	    'Ť': 'T',
	    'ť': 't',
	    'Ŧ': 'T',
	    'ŧ': 't',
	    'Ũ': 'U',
	    'ũ': 'u',
	    'Ū': 'U',
	    'ū': 'u',
	    'Ŭ': 'U',
	    'ŭ': 'u',
	    'Ů': 'U',
	    'ů': 'u',
	    'Ű': 'U',
	    'ű': 'u',
	    'Ų': 'U',
	    'ų': 'u',
	    'Ŵ': 'W',
	    'ŵ': 'w',
	    'Ŷ': 'Y',
	    'ŷ': 'y',
	    'Ÿ': 'Y',
	    'Ź': 'Z',
	    'ź': 'z',
	    'Ż': 'Z',
	    'ż': 'z',
	    'Ž': 'Z',
	    'ž': 'z',
	    'ſ': 's'
	};
	
	module.exports = characterMap;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** html4-id.min.js
 **/